import ApexCharts from 'apexcharts';

export default (options = {}, valueSuffix = null) => ({
    chart: null,
    init() {
        const chartOptions = structuredClone(options);

        if (valueSuffix) {
            chartOptions.tooltip = {
                ...chartOptions.tooltip,
                y: {
                    ...chartOptions.tooltip?.y,
                    formatter: (value) => `${value}${valueSuffix}`,
                },
            };
        }

        this.chart = new ApexCharts(this.$refs.container, chartOptions);
        this.chart.render();
    },
    destroy() {
        this.chart?.destroy();
        this.chart = null;
    },
});
